import URI from 'urijs';
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {APIError} from "../common/errors";

export function getNotifications$({ offset, sortoffset }) {
  let url = URI.joinPaths(API_BASE, 'notifications');
  let query = {
    limit: RESULT_LIMIT,
    sortby: 'datecreated',
    sortorder: 'ascending',
    offset,
    sortoffset
  };
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function markNotificationsSeen$({ notificationIds = [] }) {
  let url = URI.joinPaths(API_BASE, 'notifications', 'seen');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: notificationIds, headers: { 'Content-Type': 'application/json'} });
}

// this is called to signal the server that the user is now active on the site and that further notifications should
// be moved to a materialized view
export function switchToActiveNotifications$() {
  let url = URI.joinPaths(API_BASE, 'notifications', 'active');
  return ajaxAuthed({ url: url.toString(), method: 'POST' });
}



// WEBPACK FOOTER //
// ./src/services/notifications.js